module.exports = "/assets/72ff2bc5e164c263ca922f75e5d451d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/HG.png
// module id = 1439
// module chunks = 0